import { useMutation } from '@apollo/client';
import { FC } from 'react';

import { UploadApplication } from '@xing-com/crate-common-graphql-types';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import {
  VideoFormUpdate,
  type VideoFormUpdateProps,
} from '@xing-com/crate-video-upload';

import { DeleteVideoDocument } from '../../graphql/mutations/delete-video-mutation.gql-types';
import type { UpdateVideoMutationVariables } from '../../graphql/mutations/update-video-mutation.gql-types';
import { UpdateVideoDocument } from '../../graphql/mutations/update-video-mutation.gql-types';

type Props = Omit<
  VideoFormUpdateProps,
  'updateVideoMutation' | 'deleteVideoMutation' | 'application'
>;
export const EntityPageVideoUpdate: FC<Props> = (props) => {
  const { pageContext } = usePageContext();

  const [updateVideo] = useMutation(UpdateVideoDocument);
  const [deleteVideo] = useMutation(DeleteVideoDocument);

  const handleUpdateVideo = async (
    mediaId: string,
    videoData: UpdateVideoMutationVariables['videoData']
  ): Promise<void> => {
    const { data, errors } = await updateVideo({
      variables: {
        mediaId: mediaId,
        pageId: pageContext.pageId,
        videoData: videoData,
      },
    });

    const error = data?.entityPageUpdateVideoMedia?.error || errors;
    if (error) {
      throw error;
    }
  };
  const handleDeleteVideo = async (mediaId: string): Promise<void> => {
    const { data, errors } = await deleteVideo({
      variables: {
        mediaId: mediaId,
        pageId: pageContext.pageId,
      },
    });

    const error = data?.entityPageDeleteMedia?.error || errors;
    if (error) {
      throw error;
    }
  };

  return (
    <VideoFormUpdate
      application={UploadApplication.EntityPages}
      updateVideoMutation={handleUpdateVideo}
      deleteVideoMutation={handleDeleteVideo}
      {...props}
    />
  );
};
